import { CalendarDays } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import spotifyLogo from "@/assets/spotify-logo.png";

const ComingSoonSection = () => {
  const comingSoonFeatures = [
    {
      icon: CalendarDays,
      title: "Appointments",
      description: "Create and manage appointment scheduling for services, consultations, and paid bookings.",
      category: "Business",
      isImage: false
    },
    {
      icon: spotifyLogo,
      title: "Spotify Player",
      description: "Control your Spotify playback and manage playlists directly from your workspace.",
      category: "Entertainment",
      isImage: true
    }
  ];

  return (
    <section className="pt-0 pb-16 bg-background">
      <div className="container mx-auto px-6">
        {/* Divider */}
        <div className="flex items-center justify-center mb-16">
          <Separator className="flex-1 max-w-xs" />
          <span className="px-4 text-sm font-medium text-muted-foreground">
            COMING SOON
          </span>
          <Separator className="flex-1 max-w-xs" />
        </div>

        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
            {comingSoonFeatures.map((feature, index) => (
              <div 
                key={index} 
                className={`group p-6 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-lg relative overflow-hidden`}
              >
                {/* Coming Soon Badge */}
                <div className="absolute top-4 right-4 px-2 py-1 bg-primary/10 rounded-full">
                  <span className="text-xs font-medium text-primary">Coming Soon</span>
                </div>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    {feature.isImage ? (
                      <img src={feature.icon as string} alt={feature.title} className="w-6 h-6 object-contain" />
                    ) : (
                      (() => {
                        const IconComponent = feature.icon as React.ComponentType<{ className?: string }>;
                        return <IconComponent className="w-6 h-6 text-primary" />;
                      })()
                    )}
                  </div>
                </div>
                
                <div className="space-y-2">
                  <p className="text-sm font-medium text-muted-foreground">
                    {feature.category}
                  </p>
                  <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoonSection;